import { NgIf } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { HeaderComponent } from '@components/header/header.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule, Location } from '@angular/common'
import { Router } from '@angular/router';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { LinkComponent } from '@components/link/link.component';
import { ApiService } from 'app/services/api.service';
import { ColumnConfig, ColumnFormat, TableComponent } from '@components/table/table.component';
import { TransactionData } from 'app/interfaces/transaction-data.interface';
import { PaginationComponent } from '@components/pagination/pagination.component';
import { RedeemedReward } from 'app/interfaces/redeemed-reward.interface';

@Component({
    selector: 'app-mypoints',
    templateUrl: './redeemed-rewards.component.html',
    styleUrl: './redeemed-rewards.component.scss',
    standalone: true,
    imports: [HeaderComponent, TranslateModule, NgIf, ButtonComponent, CosentinoSvgComponent, LinkComponent, CommonModule, TableComponent, PaginationComponent],
})
export class RedeemedRewardsSummaryComponent {
    public currentPage: number = 0
    public totalPages: number = 0

    public redeemedRewards: RedeemedReward[] = []

    constructor(private location: Location, private router: Router, private api: ApiService, private translateService: TranslateService) {}

    ngOnInit() {
        const userInfo = localStorage.getItem('weUserInfo')
        if (userInfo) {
            this.api.getPointsRedeemed(this.currentPage).subscribe({
                next: (response) => {
                    this.redeemedRewards = response.items
                    this.totalPages = response.totalPages
                },
                error: (error: any) => console.log(error),
            })
        }
    }
    goBack() {
        this.location.back()
    }
    goToMyPoints() {
        this.router.navigate(['/my-rewards'])
    }

    getFormattedDate(): string {
        const currentDate = new Date()
        const currentLang = this.translateService.currentLang || 'es'
        
        // Mapear idiomas a locales
        const localeMap: { [key: string]: string } = {
            'es': 'es-ES',
            'en': 'en-US',
            'en-gb': 'en-GB',
            'en-ca': 'en-CA',
            'en-au': 'en-AU',
            'fr': 'fr-FR',
            'fr-ca': 'fr-CA',
            'de': 'de-DE',
            'it': 'it-IT',
            'pt': 'pt-BR',
            'nl': 'nl-NL',
            'pl': 'pl-PL',
            'da': 'da-DK',
            'no': 'no-NO',
            'sv': 'sv-SE',
            'fi': 'fi-FI',
            'tr': 'tr-TR',
            'iw': 'he-IL',
            'ja': 'ja-JP'
        }
        
        const locale = localeMap[currentLang] || 'es-ES'
        
        return currentDate.toLocaleDateString(locale, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }
}
